export default __webpack_public_path__ + "static/media/ethLogo.e5a979e2.svg";